// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__alz-5","newExpiryDate":"styles_newExpiryDate__nlPTJ","footer":"styles_footer__2H65h"};